import styled from 'styled-components';

export const VerticalSeparator = styled.div`
  width: 1px;
  background-color: ${({ theme }) => theme.colors.gray3};
  height: 50px;
`;

export const HorizontalSepator = styled.div`
  height: 1px;
  box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.1);
`;
